export default __webpack_public_path__ + "static/media/59t.f3bb63d3.jpg";